<template>
  <!-- 新建用户 || 修改用户-->
  <div class="setting-dialog">
    <my-dialog-form
      :dialog-form-visible="isShowAddUserDialog"
      :confirm-bottom-text="formTitle === '新增用户'?'新增':'确定'"
      :form-title="formTitle"
      :width="314"
      custom-class="user-form deal-user-form"
      @confirmOk="confirmBtn($event, 'addUserForm')"
    >
      <template #body>
        <el-form
          ref="addUserForm"
          :model="addUserForm"
          :rules="rules"
          label-position="left"
        >
          <el-form-item
            label="姓名："
            :label-width="formLabelWidth"
            prop="realName"
          >
            <el-input
              v-model="addUserForm.realName"
              class="form-name"
              autocomplete="off"
              :disabled="disabledInput"
            />
          </el-form-item>
          <el-form-item
            label="账号："
            :label-width="formLabelWidth"
            prop="account"
            class="regular"
          >
            <el-input
              v-model="addUserForm.account"
              autocomplete="off"
              class="w150px"
              :disabled="disabledInput"
            />
          </el-form-item>
          <el-form-item
            :label-width="formLabelWidth"
            label="科室："
            prop="Department"
          >
            <el-select
              v-model="addUserForm.Department"
            >
              <el-option
                v-for="item in departmentOptions"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label-width="formLabelWidth"
            label="小组："
            prop="group"
            class="regular"
          >
            <el-checkbox-group v-model="addUserForm.group">
              <el-checkbox v-for="item in specialGroupOptions" :key="item.value" :label="item.label"/>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
            label="角色："
            :label-width="formLabelWidth"
            prop="Utype"
          >
            <el-select v-model="addUserForm.Utype">
              <el-option
                v-for="item in UtypeOptions"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="电话："
            :label-width="formLabelWidth"
            prop="phoneNumber"
            class="telePhone"
          >
            <el-input
              v-model="addUserForm.phoneNumber"
              autocomplete="off"
              class="w180px"
            />
          </el-form-item>

        </el-form>
      </template>
    </my-dialog-form>
    <my-dialog
      :width="390"
      :dialog-carted="isShowSimpleDialog"
      title="提示"
      @confirmOk="isShowSimpleDialog = false"
    >
      <template #content>
        <div>{{ isSimpleDialogMessage }}</div>
      </template>
    </my-dialog>
    <my-dialog-form
      v-model="isShowTwoOptionDialog"
      :width="400"
      title="提示"
      :confirm-bottom-text="actionRowData.dealUserAction"
      @confirmOk="clickTwoOptionDialog"
    >
      <template #body>
        <div>您正在{{ actionRowData.dealUserAction }}
          <span class="deal-user">[{{ actionRowData.realName }}]</span>
          {{ actionRowData.dealUserDetail }}
        </div>
      </template>
    </my-dialog-form>

    <my-dialog-form
      v-model="isShowDeleteNotice"
      :width="400"
      title="提示"
      confirm-bottom-text="确定"
      @confirmOk="clickDeleteNotice"
    >
      <template #body>
        <div>
          <div v-for="item in deleteNoticeData" :key="item.name">
            <div>
              {{ item.name }}下含有: {{ item.user.join("，") }}
            </div>
            <div>是否继续删除该字段组</div>
          </div>
        </div>

      </template>
    </my-dialog-form>

    <my-dialog-form
      v-model="isShowNewRoom"
      :width="400"
      title="添加"
      confirm-bottom-text="新增"
      custom-class="user-form deal-room-form"
      @confirmOk="addNewStructure"
    >
      <template #body>
        <el-form
          ref="addUserRoomFormRef"
          :model="addStructureForm"
          label-position="left"
        >
          <el-form-item
            label="类别："
            :label-width="formRoomLabelWidth"
            class="form-room"
            prop="room"
          >
            <el-select
              v-model="addStructureForm.type"
              placeholder="-------"
            >
              <el-option
                v-for="item in addStructureOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="名称："
            :label-width="formRoomLabelWidth"
            prop="name"
          >
            <el-input
              v-model="addStructureForm.name"
              class="form-name"
              autocomplete="off"
            />
          </el-form-item>
          <el-form-item
            label="备注："
            :label-width="formRoomLabelWidth"
            prop="note"
          >
            <el-input
              v-model="addStructureForm.note"
              class="form-name"
              autocomplete="off"
            />
          </el-form-item>
        </el-form>
      </template>
    </my-dialog-form>
    <my-dialog-form
      v-model="isShowDeleteRoom"
      :width="400"
      title="删除"
      confirm-bottom-text="删除"
      custom-class="user-form delete-room-form"
      @confirmOk="isDeleteRoom"
    >
      <template #body>
        <div>
          <div class="title">请选择对应的字段</div>
          <ul class="menu-container">
            <li
              v-for="item in allDepartmentGroup"
              :key="item.value"
              class="menu-level1"
              @click="clickMenu($event,item.label)"
              @dblclick.native="dbClickMenu(item.label)"
            >
              <div :class="{'is-selected':activeMenu.includes(item.label)} ">
                <i :class="[!expandMenu.includes(item.label) ? 'el-icon-arrow-right' : 'el-icon-arrow-down'] "/>
                <span class="room-title">{{ item.label }}</span>
              </div>
              <ul class="menu-sub" :class="[!expandMenu.includes(item.label)? 'hide-menu':'show-menu']">
                <li v-for="person in item.users" :key="person.id">
                  {{ person.name }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </template>
    </my-dialog-form>
  </div>
</template>

<script>
import MyDialogForm from "@components/customDialog/MyDialogForm.vue";
import MyDialog from "@components/customDialog/MyDialog.vue";
import { addNewUser, dealAllUser, deleteUser } from "@api/user";
import userSetting from "@components/setting/UserSetting/userSetting";
import { deleteHospitalDepartments, getHospitalDepartments, setHospitalDepartments } from "@api/getOptions";
import { showWindowMessage } from "@utils/notification";
import { mapState } from "vuex";

export default {
  name: "ManyDialog",
  components: {
    MyDialog,
    MyDialogForm
  },
  mixins: [userSetting],
  props: {
    formTitle: {
      type: String,
      default() {
        return "";
      }
    },
    // 添加用户/ 修改用户
    showAddNewUserDialog: {
      type: Boolean,
      default: false
    },
    // 确定删除 / 重置密码
    showTwoOptionDialog: {
      type: Boolean,
      default: false
    },
    // 要被修改的用户信息
    changeUserData: {
      type: Object,
      default() {
        return {};
      }
    },
    // 重置 / 删除的确定弹窗数据
    actionRowData: {
      type: Object,
      default() {
        return {};
      }
    },

    // 添加新科室的数据
    showNewRoom: {
      type: Boolean,
      default() {
        return false;
      }
    },
    // 展示删除科室弹窗
    showDeleteRoom: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  emits: ["closeTwoOptions", "closeDialog", "closeNewRoom", "closeDeleteRoom", "getDepartmentGroupOptions"],
  data() {
    return {
      addStructureOptions: [{
        label: "科室",
        value: "depart"
      }, {
        label: "急救小组",
        value: "group"
      }],
      isShowDeleteNotice: false,
      deleteNoticeData: [],
      isChangeUserData: {},
      isSimpleDialogMessage: "",
      isShowSimpleDialog: false,
      formLabelWidth: "65px",
      dialogFormVisible: false, // 打开 组件 新加用户弹窗
      departmentOptions: [],
      specialGroupOptions: [],
      allDepartmentGroup: [], // 急救小组和科室的集合
      formRoomLabelWidth: "80px",
      addStructureForm: {
        type: "",
        name: "",
        note: ""
      },
      expandMenu: [], // 删除结构 展开列表的id
      activeMenu: [], // 删除结构 选中的id们
      addUserForm: {
        // 添加用户表单数据
        // 以下的需要采集信息上传并且采集
        // realName: "",
        // account: "",
        // phoneNumber: "",
        // Department: "",
        // hospitalId: "",
        // group: [], // 特勤小组
        // Utype: "",
        // // 以下的只上传,不用采集信息
        // mailBox: "",
        // name: "",
        // password: "",
      },
    };
  },

  computed: {
    ...mapState({
      hospitalInfo: "hospitalInfo",
      userInfo: "userInfo",
      hospitalID: "hospitalID",
    }),
    isShowAddUserDialog() {
      return this.showAddNewUserDialog;
    },
    isShowNewRoom() {
      return this.showNewRoom;
    },
    isShowDeleteRoom() {
      return this.showDeleteRoom;
    },
    isShowTwoOptionDialog() {
      return this.showTwoOptionDialog;
    },
    disabledInput() {
      return this.addUserForm.type === "information";
    }
  },
  watch: {
    changeUserData: {
      handler(val) {
        const defaultUserData = {
          realName: "",
          account: "",
          phoneNumber: "",
          Department: "",
          hospitalId: "",
          group: [],
          Utype: "",
          mailBox: "",
          name: "",
          password: "",
        };
        this.addUserForm = val ? { ...val } : { ...defaultUserData };
      },
      immediate: true
    }
  },
  mounted() {
    this.addUserForm.hospitalId = this.hospitalID;
    this.getOptions(); // 获得选项
  },
  methods: {
    /**
     * 确定删除不为空的小组或者科室
     * */
    clickDeleteNotice(e) {
      this.isShowDeleteNotice = false;
      if (e === "confirm") {
        this.actualDelete();
      }
    },
    /**
     * 单击这个科室选中, 同时要注意shift多选
     * @param {event} event - event
     * @param {number} id - 选中的id
     * */
    clickMenu(event, id) {
      const { shiftKey } = event;
      const isAdded = this.activeMenu.includes(id);
      if (isAdded) {
        this.activeMenu.splice(this.activeMenu.indexOf(id), 1);
        if (!shiftKey) {
          this.activeMenu = [];
          this.activeMenu.push(id);
        }
      } else {
        !shiftKey && (this.activeMenu = []);
        this.activeMenu.push(id);
      }
    },
    /**
     * 双击展开科室
     * @param {number} id - 点击的id
     * */
    dbClickMenu(id) {
      const isAdded = this.expandMenu.includes(id);
      if (isAdded) {
        this.expandMenu.splice(this.expandMenu.indexOf(id), 1);
      } else {
        this.expandMenu.push(id);
      }
    },
    /**
     * 删除小组的确定弹窗
     * @param {string} e - 如果点击的是确定 那么是confirm. 否则是undefined
     *
     * */
    async isDeleteRoom(e) {
      if (e === "confirm") {
        const list = this.activeMenu
          .map(item => this.allDepartmentGroup.find(gr => gr.label === item))
          .filter(item => item.users.length !== 0);
        if (list.length) {
          this.deleteNoticeData = list.map(item => ({ name: item.label, user: item.users.map(user => user.name) }));
          this.isShowDeleteNotice = true;
        } else {
          await this.actualDelete();
        }
      } else {
        this.$emit("closeDeleteRoom");
      }
    },
    /**
     * 真实开始删除
     * */
    async actualDelete() {
      const data = {
        name: {
          depart: [],
          group: []
        }
      };

      for (const active of this.activeMenu) {
        const item = this.allDepartmentGroup.find(item => item.label === active);
        data.name[item.type].push(active);
      }

      try {
        const { code, msg } = await deleteHospitalDepartments(JSON.stringify(data));
        showWindowMessage(code === 200 ? 4 : 3, msg, this);
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    /**
     * 新增小组的确定弹窗
     * @param {string} e - 如果点击的是确定 那么是confirm. 否则是undefined
     *
     * */
    async addNewStructure(e) {
      this.$emit("closeNewRoom");
      if (e === "confirm") {
        let code, msg;
        try {
          ({ code, msg } = await setHospitalDepartments(this.addStructureForm));
          if (code === 200) {
            showWindowMessage(4, msg, this);
          } else {
            this.isShowSimpleDialog = true;
            this.isSimpleDialogMessage = msg;
          }
        } catch (e) {
          showWindowMessage(3, e, this);
        }
      }
      this.$refs["addUserRoomFormRef"].resetFields();
    },
    /**
     * 关闭弹窗 删除 重置这些
     * @param {string} type - 点击的类型 confirm 代表是确定, undefined 代表是取消
     * */
    async clickTwoOptionDialog(type) {
      this.$emit("closeTwoOptions");
      if (type === "confirm") {
        const { dealUserAction, id } = this.actionRowData;
        try {
          const type = dealUserAction === "删除" ? "delete" : "password";
          const { code, msg } = await deleteUser({ id, type });
          if (code !== 200) {
            showWindowMessage(3, msg, this);
          }
        } catch (e) {
          showWindowMessage(3, e, this);
        }
      }
    },
    transformOptions(options, type) {
      return options.map((e) => {
        e.value = e.id;
        e.label = e.department || e.group; // 这里假设 department 和 group 的名称不相同
        e.type = type;
        delete e.id;
        delete e.department;
        delete e.group;
        return e;
      });
    },
    /**
     * 获得下拉框的各种选项
     * */
    async getOptions() {
      let res, res2;

      try {
        [res, res2] = await Promise.all([getHospitalDepartments(), dealAllUser({ type: "depart" })]);
        if (res.code !== 200 || res2.code !== 200) {
          showWindowMessage(3, "获取部门和小组信息失败", this);
          return;
        }
      } catch (e) {
        showWindowMessage(3, "获取部门和小组信息失败", this);
        return;
      }

      const { department, group } = res;
      this.departmentOptions = this.transformOptions(department, "depart");
      this.specialGroupOptions = this.transformOptions(group, "group");
      this.allDepartmentGroup = [...this.specialGroupOptions, ...this.departmentOptions];
      const { role_list } = res2;
      this.$emit("getDepartmentGroupOptions", this.allDepartmentGroup);
      this.UtypeOptions = role_list;
    },
    /**
     * 点击表单 弹窗的确定按钮
     * @param {string} e - 点击确定还是点击关闭 最终都会走到这里
     * @param {Object} form - 提交的表单数据
     * */
    confirmBtn(e, form) {
      // 监听到子组件的点击确定按钮
      if (e === "confirm") {
        this.$refs[form].validate(async (valid) => {
          if (valid) {
            this.$emit("closeDialog");
            // 新增是post请求,  修改是put请求
            let method = "post";
            if (this.addUserForm.type === "information") {
              method = "put";
            }
            const { msg } = await addNewUser(JSON.stringify(this.addUserForm), method);
            this.isShowSimpleDialog = true;
            this.isSimpleDialogMessage = msg;
            this.$refs[form].resetFields();
          } else {
            return false;
          }
        });
      } else {
        this.$refs[form].resetFields();
        this.$emit("closeDialog");
      }
    },
  }
};
</script>

<style scoped lang="scss">
.menu-sub,
.room-title {
  user-select: none;
}

::v-deep .deal-user-form {
  .el-dialog__body {
    display: block;
    padding-bottom: 0;
  }

  .el-form {
    .el-form-item__label {
      font-size: 16px;
      color: #666666;
      padding-right: 0;
    }

    .el-form-item {
      margin-bottom: 16px;
    }

    .el-input__icon,
    .el-input {
      width: auto;
      line-height: 32px;
    }

    .el-input__inner {
      height: 32px;
      width: 160px;
      border: 1px solid #999999;
      border-radius: 10px;
      min-height: 32px;
    }

    .form-name {
      .el-input__inner {
        width: 100px;
      }
    }
  }
}

::v-deep .deal-room-form {
  .el-dialog__body {
    display: block;
    padding-bottom: 0;
  }

  .el-form {
    .el-form-item__label {
      font-size: 16px;
      color: #666666;
      padding-right: 0;
    }

    .el-form-item {
      margin-bottom: 16px;
    }

    .el-input {
      width: auto;
      line-height: 32px;
    }

    .el-input__inner {
      height: 32px;
      width: 220px;
      border: 1px solid #999999;
      border-radius: 10px;
      min-height: 32px;
    }

    .form-room {
      .el-input__inner {
        width: 140px;
      }
    }
  }
}

::v-deep .delete-room-form {
  .el-dialog__body {
    display: block;
    padding-bottom: 0;
    height: 300px;
    overflow: auto;
  }

  .menu-container {
    cursor: pointer;
    margin-top: 24px;
  }

  .menu-sub {
    padding-left: 16px;

    li {
      margin-top: 6px;
    }
  }

  .hide-menu {

    display: none;
  }

  .menu-level1 {
    font-size: 16px;
    color: #333333;
    margin-bottom: 20px;
  }

  .show-menu {
    display: block;
  }

  li {
    list-style: none;
  }

  .is-selected {
    .room-title,
    .el-icon-arrow-down {
      color: #2AA5E3;
    }
  }
}
</style>
